import './Forgotpw.css';

import { Component } from 'react';
import { Flow } from 'flow-react';
import { Container, Row, Col} from 'react-bootstrap';
import { useParams } from "react-router-dom";



function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


class Forgotpw extends Component {
	
  state = { initdone:false, pwchanged:false, showinputs:true ,mess:'' }

	newpw1 = '';
	newpw2 = '';
	mess = '';


	componentDidMount = () => {
		this.prelogin();
		
	}
		
	prelogin = () => {
    if (this.state.initdone)
      this.resetpwstep1();
    else
      this.props.flow.init()
        .then(()=>{ 
          this.setState({initdone: true});
          this.resetpwstep1();
          // this.trybaseLogin();
				});
  }
	// async trybaseLogin() {
		// this.props.flow.login('pjdemo_dummy_1','gDw5%_wE')
			// .then(res=>{
				// this.resetpwstep1()
			// }).catch(e => {
				// console.error(e);
		// });
	// }

	resetpwstep1  = () => {
		this.props.flow.ftvfeResetPw1(this.props.params.resetid)
			.then(res=>{
				if(res.success === false) {
					this.setState({pwchanged: false,showinputs: false,mess:'Utilisateur introuvable'});
				}	
			}).catch(e => {
				console.error(e);
		});
	}
	
  changeInput = evt => {
    this[evt.target.name] = evt.target.value;
  }

	chkpsw = () => {
		if(this.newpw1.length < 8 || this.newpw1.match(/[A-Z]/) == null) {
			this.setState({pwchanged: false,mess:'8 caractères et une capitale minimum'});
			return false;
		}
		else if(this.newpw1 != this.newpw2) {
			this.setState({pwchanged: false,mess:'Password do not match'});
			return false;
		}
	}

  handleSubmit = evt => {
		evt.preventDefault();
		if(this.chkpsw() === false) {
			return false;
		}
    this.props.flow.ftvfeResetPw2(this.newpw1)
      .then(res=>{
          this.setState({mess:res.msg,showinputs: false,pwchanged:res.success});
      }).catch(e => {
					console.log(e);
      });
  }
	
	gotologin = () => {
		window.location.href='/ftvpreview'
	}


  render() {
		let errdiv = null;
		if(this.state.mess != '') {
			errdiv = <div className="pwreset smallerrormess">{ this.state.mess }</div>
			if(this.state.pwchanged)  errdiv = <div className="pwreset smallsuccessmess">{ this.state.mess }</div>
		}
    return (
			<Container className="Login" fluid>
				<Row>
				<Col md={1} /> 
					<Col md={11}> 
						<form className="form" onSubmit={this.handleSubmit}>
							<div className="formrow">
								<div className="pwforgot_instruct">Veuillez renseigner un nouveau mot de passe.</div>
							</div>
							{errdiv}
							{this.state.showinputs && (
								<>
									<div className="formrow">
										<div>Mot de passe</div>
										<input type="password" placeholder = "8 caractères et une capitale minimum" name="newpw1" onChange={ this.changeInput } />
									</div>
									<div className="formrow">
										<div>Confirmer le mot de passe</div>
										<input type="password" name="newpw2" onChange={ this.changeInput } />
									</div>
									<div className="formrow logbutrow">
										<input className="loginsubmit" type="submit" value="Envoyer" />
									</div>
								</>
							)}
							<div onClick={ this.gotologin  } className="pwforgotlink">Se connecter</div>
						</form>

					</Col>
				</Row>
      </Container>
    );
  }

}

export default Flow.injectFlow(withParams(Forgotpw));